import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const RadiusAccountRoutes = defineRoute({
    record: {
        route: {
            path: "/radius-account",
            component: () => loadView(import("./RadiusAccountTable.vue")),
        },
    },
    create: {
        route: {
            path: "/radius-account/create",
            component: () => loadView(import("./RadiusAccountCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/radius-account/update/:id",
            component: () => loadView(import("./RadiusAccountUpdate.vue")),
        },
        build(id: string) {
            return `/radius-account/update/${id}`;
        },
    },
});
